import { Component, Vue } from 'vue-property-decorator'
import { getProjectMarketCooperationById } from '@/api/projectList'

@Component({})
export default class PartnerProjectInfo extends Vue {
    infoData = {}
    id: number = undefined

    created() {
        this.id = Number(this.$route.query.id)
        this.getData()
    }

    async getData() {
        const data: any = await getProjectMarketCooperationById(this.id)
        this.infoData = data.projectMarketCooperation
    }
}